import { ITranslations } from 'types/common';
import { BrandTransFields } from './types';
import en from 'translations/en/brand.json';
import pl from 'translations/pl/brand.json';
import sl from 'translations/sl/brand.json';

export const brandTranslations: ITranslations<BrandTransFields> = {
  name: 'brand',
  en,
  pl,
  sl,
};
